import { Box, Flex, FloraTypography } from '@grupoboticario/flora-react'

import {
  checkboxItemBoxStyle,
  checkboxItemBoxTextStyle,
  checkboxItemLabelStyle,
  checkboxItemFlexStyle
} from '@/components/EventSiteDisplay/styles'

const CheckboxItem = ({ checked, label, onChange, disabled }) => (
  <Flex align="center" as="label" css={checkboxItemFlexStyle(disabled)}>
    <Box css={checkboxItemBoxStyle}>
      {checked && (
        <FloraTypography css={checkboxItemBoxTextStyle} fontSize="bodyLargeStandard">
          ✓
        </FloraTypography>
      )}
    </Box>
    <input
      checked={checked}
      disabled={disabled}
      onChange={(e) => !disabled && onChange(e.target.checked)}
      style={{ display: 'none' }}
      type="checkbox"
    />
    <FloraTypography css={checkboxItemLabelStyle} fontSize="bodyLargeStandard">
      {label}
    </FloraTypography>
  </Flex>
)

export default CheckboxItem
